import store from "../../store";

const pathIfAdmin = (path) => store.getters.isAdmin ? "/admin" + path : path;

const RoutesPaths = {
  app: {
    loadApp: () => pathIfAdmin("/carregar-app"),
  },
  emptyHome: {
    rootName: () => pathIfAdmin("/inicio-vazio"),
  },
  home: {
    rootName: () => pathIfAdmin("/inicio"),
  },
  register: {
    rootName: () => pathIfAdmin("/cadastro"),
    taxLicense: () => pathIfAdmin("/cadastro/impostos-alvara"),
    paymentOptions: () => pathIfAdmin("/cadastro/meios-pagamento"),
    attendencePlace: () => pathIfAdmin("/cadastro/local-atendimento"),
    medicalSpecialities: () => pathIfAdmin("/cadastro/especialidades-medicas"),
    personalInformation: () => pathIfAdmin("/cadastro/informacoes-pessoais"),
  },
  documents: {
    rootName: () => pathIfAdmin("/documentos"),
  },
  declarations: {
    rootName: () => pathIfAdmin("/declaracoes"),
    cooperativeDeclaration: () => pathIfAdmin("/declaracoes/declaracao-cooperado"),
    incomeHistory: () => pathIfAdmin("/declaracoes/historico-rendimento"),
    inss: () => pathIfAdmin("/declaracoes/inss"),
    iss: () => pathIfAdmin("/declaracoes/iss"),
    ltcatpp: () => pathIfAdmin("/declaracoes/ltcatpp"),
    others: () => pathIfAdmin("/declaracoes/outras"),
  },
  benefit: {
    rootName: () => pathIfAdmin("/beneficios"),
    healthPlan: () => pathIfAdmin("/beneficios/plano-saude"),
    benefactor: () => pathIfAdmin("/beneficios/benemerito"),
    funeralAssistance: () => pathIfAdmin("/beneficios/auxilio-funeral"),
    temporaryAssistance: () => pathIfAdmin("/beneficios/auxilio-temporario"),
    absence: () => pathIfAdmin("/beneficios/afastamento"),
    otherSolicitation: () => pathIfAdmin("/beneficios/outra-solicitacao"),
  },
  financial: {
    rootName: () => pathIfAdmin("/financeiro"),
    analytics: () => pathIfAdmin("/financeiro/analitica"),
    productionManagement: () => pathIfAdmin("/financeiro/gestao-de-producao"),
    reportIncome: () => pathIfAdmin("/financeiro/informe-rendimentos"),
    quotaStatement: () => pathIfAdmin("/financeiro/cota-capital"),
    sustainabilityFund: () => pathIfAdmin("/financeiro/fundo-sustentabilidade"),
    incomeHistory: () => pathIfAdmin("/financeiro/historico-notas-fiscais"),
    backbeat: () => pathIfAdmin("/financeiro/backbeat"),
    backbeatKnowMore: () => pathIfAdmin("/financeiro/backbeat-saiba-mais"),
    reviewGlosses: () => pathIfAdmin("/financeiro/recurso-glosas"),
    reportVoxis: () => pathIfAdmin("/financeiro/relatorio-glosas-voxis"),
    annuityRefund: () => pathIfAdmin("/financeiro/reembolso-anuidade"),
  },
  contentManagement: {
    rootName: () => pathIfAdmin("/gestao-conteudo"),
    assemblyManagement: () => pathIfAdmin("/gestao-assembleia"),
    assemblyManagementForm: (id) => pathIfAdmin("/formulario-gestao-assembleia/" + (id || "")),
    assemblyParticipantsReportManagement: () => pathIfAdmin("/relatorio-participantes-assembleia"),
    assemblyParticipation: () => pathIfAdmin("/participacao-assembleia"),
  },
  contentTrainingManagement: {
    rootName: () => pathIfAdmin("/gestao-conteudo-treinamento"),
  },
  contentReportManagement: {
    rootName: () => pathIfAdmin("/gestao-conteudo-relatorio"),
  },
  faq: {
    rootName: () => pathIfAdmin("/perguntas-frequentes"),
  },
  requestHistory: {
    rootName: () => pathIfAdmin("/historico-solicitacoes"),
  },
  useTerm: {
    rootName: () => pathIfAdmin("/termos-uso"),
    accepted: () => pathIfAdmin("/termos-uso/aceito"),
  },
  fileManagement: {
    rootName: () => pathIfAdmin("/gestao-arquivos"),
  },
  trainingManagement: {
    rootName: () => pathIfAdmin("/gestao-treinamentos"),
    form: (id) => pathIfAdmin("/formulario-gestao-treinamento/" + (id || ""))
  },
  medicalGuideManagement: {
    rootName: () => pathIfAdmin("/gestao-guia-medico"),
  },
  certificationManagement: {
    rootName: () => pathIfAdmin("/gestao-certificacoes"),
    form: (id) => pathIfAdmin("/formulario-gestao-certificacao/" + (id || ""))
  },
  linkCertificationTrainingManagement: {
    rootName: () => pathIfAdmin("/vincular-certificacao-treinamento"),
    form: (id) => pathIfAdmin("/formulario-vincular-certificacao-treinamento/" + (id || ""))
  },
  reportParticipation: {
    rootName: () => pathIfAdmin("/relatorio-participacao"),
  },
  reports: {
    rootName: () => pathIfAdmin("/relatorio-visualizacoes-portal"),
  },
  login: {
    rootName: () => pathIfAdmin("/login"),
  },
  virtualOffice: {
    rootName: () => pathIfAdmin("/consultorio-virtual"),
  },
  institutionalPage: {
    rootName: () => pathIfAdmin("/pagina-institucional"),
    panelEconomic: () => pathIfAdmin("/painel-economico"),
  },
  documentsAtasPage: {
    rootName: () => pathIfAdmin("/pagina-institucional"),
    documentsAtas: () => pathIfAdmin("/documentos-atas"),
  },
  passwordRecovery: {
    rootName: () => pathIfAdmin("/recuperacao-senha"),
    change: () => pathIfAdmin("/recuperacao-senha/alterar/:id"),
    sucess: () => pathIfAdmin("/recuperacao-senha/sucesso"),
  },
  trainingPage: {
    rootName: () => pathIfAdmin("/pagina-treinamento"),
  },
  communicationManagement: {
    rootName: () => pathIfAdmin("/gestao-comunicacao"),
    form: (id) => pathIfAdmin("/formulario-gestao-comunicacao/" + (id || "")),
    reportManagement: () => pathIfAdmin("/relatorio-gestao-comunicacao"),

  },
  externalLinkManagement: {
    form: () => pathIfAdmin("/gestao-links-externos")
  },
  gratification: {
    rootName: () => pathIfAdmin("/gratificacao"),
  },
  connection: {
    rootName: () => pathIfAdmin("/conexao"),
    preview: (id) => pathIfAdmin("/conexao/visualizacao/" + id),
  },
  annuityRefund: {
    rootName: () => pathIfAdmin("/reembolso-anuidade"),
  },
  contactEmergencyReport : {
    rootName: () => pathIfAdmin("/relatorio-contato-emergencia"),
  }
};

export default RoutesPaths;
